module.exports = __webpack_public_path__ + "img/OPTIONS.11caa6fe.png";